import React from 'react'
import PropTypes from 'prop-types'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'

export const Popper = (props) => {
  const { trigger, overlay, children, ...rest } = props

  return (
    <OverlayTrigger rootClose trigger={trigger} overlay={overlay} {...rest}>
      {children ? children : <span className="popoverTrigger" />}
    </OverlayTrigger>
  )
}

Popper.propTypes = {
  /**
   * Specify which action or actions trigger Overlay visibility
   *
   * @type {'hover' | 'click' | 'focus' | ['hover' | 'click' |'focus']}
   */
  trigger: PropTypes.oneOfType([
    PropTypes.oneOf(['click', 'hover', 'focus']),
    PropTypes.arrayOf(PropTypes.oneOf(['hover', 'click', 'focus'])),
  ]),

  /** Sets the direction the Popover is positioned towards. */
  placement: PropTypes.oneOf(['auto', 'top', 'bottom', 'left', 'right']),

  /**
   * A millisecond delay amount to show and hide the Overlay once triggered
   */
  delay: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      show: PropTypes.number,
      hide: PropTypes.number,
    }),
  ]),

  /** The initial visibility state of the Overlay. */
  defaultShow: PropTypes.bool,

  /** An element or text to overlay next to the target. */
  overlay: PropTypes.oneOfType([PropTypes.node, PropTypes.element]).isRequired,

  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
}

Popper.defaultProps = {
  placement: 'top',
  delay: { show: 250, hide: 0 },
  trigger: 'click',
}
